var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{class:_vm.inputClass,attrs:{"required":_vm.required,"name":_vm.name},domProps:{"value":_vm.phone},on:{"input":_vm.onInput}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('components.phone_input.format_hint')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }